import moment from "moment";
import Axios from "../helper/appConfig";
import { getStartOfDay, resetToMidnightFormatted, resetToMidnightFormatted1 } from "../helper/Formatter";

export const getFacilityRates = async (startDate, endDate) => {
  // const newstartdate = new Date(startDate);
  // newstartdate.setHours(0, 0, 0, 0);
  // const newendDate = new Date(endDate);
  // newendDate.setHours(0, 0, 0, 0);

  const payload = {
    startdate: startDate,
    enddate: endDate,
    webbooking: true,
  };

  return Axios.post("api/integrations/getFacilityRates", payload);
};


export const getBookRates = async (payload) => {
  return Axios.post("api/appointments/roombooking", payload);
};



export const getGuestForm = async (payload) => {
  const body = {
    search: [
      {
        searchfield: "status",
        searchvalue: "active",
        criteria: "eq",
      },
      {
        searchfield: "formname",
        searchvalue: "prospect",
        criteria: "eq",
      },
    ],
  };
  return Axios.post("api/formfields/filter", body);
};
